import { render } from "./AppPayBanner.vue?vue&type=template&id=5eb1a148&scoped=true"
import script from "./AppPayBanner.vue?vue&type=script&lang=js"
export * from "./AppPayBanner.vue?vue&type=script&lang=js"

import "./AppPayBanner.vue?vue&type=style&index=0&id=5eb1a148&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb1a148"]])

export default __exports__